import { useIntl } from 'react-intl-next';

import { useInvitePeopleContext } from '../../InvitePeople/InvitePeopleContext';
import { useInviteeListStateContext } from '../../InviteeList';
import { useProducts } from '../../ProductSelect';

import { getFailureFlag, getErrorFlag, getGenericErrorFlag, getSuccessFlag } from './getFlag';

import { type BulkInviteFailureResponse, type BulkInviteSuccessResponse } from '../../../types';

export const useInvitePeopleFlags = (onReopenHandler?: () => void) => {
	const { cloudId, userRole } = useInvitePeopleContext();
	const { selectedProducts } = useProducts();
	const { users, getName } = useInviteeListStateContext();
	const intl = useIntl();

	return {
		failure: (result: BulkInviteFailureResponse) =>
			getFailureFlag(result, cloudId!, userRole, users, selectedProducts, intl),
		error: (result: BulkInviteSuccessResponse) => getErrorFlag(result, userRole, getName, intl),
		genericError: () => getGenericErrorFlag(userRole, intl),
		success: (result: BulkInviteSuccessResponse) =>
			getSuccessFlag(result, cloudId!, userRole, selectedProducts, getName, intl, onReopenHandler),
	};
};
